import { render, staticRenderFns } from "./DiscountsLifecycle.vue?vue&type=template&id=5450a20e&scoped=true"
import script from "./DiscountsLifecycle.vue?vue&type=script&lang=js"
export * from "./DiscountsLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450a20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5450a20e')) {
      api.createRecord('5450a20e', component.options)
    } else {
      api.reload('5450a20e', component.options)
    }
    module.hot.accept("./DiscountsLifecycle.vue?vue&type=template&id=5450a20e&scoped=true", function () {
      api.rerender('5450a20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/discounts/DiscountsLifecycle.vue"
export default component.exports